import React, { useEffect } from "react";
import { Container, VStack } from "@chakra-ui/react"
import { useDecisionsQuery,useMyRolesQuery, useParticipantsQuery, useDataQuery } from "../app/api"
import { map as m,path,filter as f, prop as p, compose as C, 
  includes,__,sort,ascend,addIndex,defaultTo } from "ramda"; 
import { useParams } from "react-router-dom";
import { skip_list } from "./skippable";
import { DecisionHeader } from "./decision_header";
import { useDispatch, useSelector } from "react-redux";
import { Part } from "./part.jsx"
import { set_decision } from "../app/ui_state.js";

const Decision = () => { 
  const { id } = useParams();
  const dispatch = useDispatch();
  const session = useSelector(path(["ui","session"]));
  
  const {data:decision} = useDecisionsQuery({id});
  const {data:participants} = useParticipantsQuery({decision_id:id});
  const {data:my_roles} = useMyRolesQuery({email:session?.user?.email, decision_id:id});
  const {data} = useDataQuery(id);
  
  const skippable = data && decision && skip_list(decision,data,session)
  function show_max(x) {return skippable[x] === false ? show_max(x+1) : x;}
  const next_to_show = decision && data && show_max(decision[0].show_until+1);
  
  useEffect(() => {
    dispatch(set_decision(id));
  }, [dispatch, id]);
  /* done_item on tavaliste activity'te puhul null ja  one-by-one activity'te 
    puhul on seal item nr. Viimase one-by-one itemi viimase activity puhul 
    kirjutatakse done_item uuesti nulliks, et näitaks järgmist part'i.
    Kui konkreetse part'i esimene activity on nähtav on ka part nähtav.*/
  const first_activity_visible = ({done,done_item,show_until},{order_nr}) => {
    return ((Math.max(show_until-1,done)+(done_item !== null ? 0 : 1)) < order_nr);
  }
  const all_skipped = x => {
    const skipped = ({order_nr}) => skippable ? (skippable[order_nr] === false) : false;
    return x.activities_with_types.length === x.activities_with_types.filter(skipped).length;
  }

  return (my_roles && decision && decision[0] && participants && skippable && data && next_to_show) ? <Container pt={20} maxW={'2xl'} >
    <DecisionHeader decision={decision[0]} id={id} />
    <VStack mb={20} spacing={10} align="stretch">
      {C(
        addIndex(m)((x,n,xs) => {
          return (first_activity_visible(decision[0],x.activities_with_types[0]) || all_skipped(x)) ? null : 
          <Part 
            part={x}
            key={x.id}
            decision_id={id}
            last_part={(xs.length-1) === n}
            data={data}
            skippable={skippable}
            next_to_show={next_to_show}
            participants={participants}
            show_until={decision[0].show_until}
            done={decision[0].done}
            done_item={decision[0].done_item}
            participant_id={my_roles[0].participant_id}
          />}
        ),
        sort(ascend(p("order"))),
        f(C(includes(__,C(m(p("role_id")))(my_roles)),p("role_id"))),
        defaultTo([]),
        path([0,"decision_types","parts"])
      )(decision)}
    </VStack>
  </Container> : null;

}
export default Decision;